export default "__VITE_ASSET__B9V6eP1z__"